import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useParams } from 'react-router';


const BackgroundVerification = () => {
    const { id } = useParams();
    useEffect(() => {
        console.log("back", id)

    }, [])
    return (
        <>
            <div className='pb-[20px]'>
            <div className='top-0 flex justify-between items-center bg-white p-[30px] pr-0 pl-[0] w-[100%]'>
                <h3 className='bg-[#fff] shadow-cs pt-[10px] pb-[10px] pl-[14px] rounded-md w-full font-medium'>Background Verification</h3>
            </div>

            <div className='bg-white shadow-cs rounded-lg id-proof'>
                <h3 className='p-3 border border-t-0 border-r-0 border-b border-l-0 font-medium'>ID Proofs</h3>
                <Link className='flex justify-between items-center border-[#dbdbdb] hover:bg-[#f0f8fd] p-4 border-b' to="/verify-aadhar ">
                    <h4 className='font-normal'>Aadhaar</h4>
                    <ArrowForwardIosIcon className='allarrow-verify' />
                </Link>

                <Link className='flex justify-between items-center border-[#dbdbdb] hover:bg-[#f0f8fd] p-4 border-b' to="/verify-pan">
                    <h4 className='font-normal'>PAN</h4>
                    <ArrowForwardIosIcon className='allarrow-verify'/>
                </Link>
                <Link className='flex justify-between items-center border-[#dbdbdb] hover:bg-[#f0f8fd] p-4 border-b' to="/driving-license">
                    <h4 className='font-normal'>Driving License</h4>
                    <ArrowForwardIosIcon className='allarrow-verify'/>
                </Link>
                <Link className='flex justify-between items-center border-[#dbdbdb] hover:bg-[#f0f8fd] p-4 border-b' to="/uan">
                    <h4 className='font-normal'>UAN</h4>
                    <ArrowForwardIosIcon className='allarrow-verify'/>
                </Link>
                <Link className='flex justify-between items-center border-[#dbdbdb] hover:bg-[#f0f8fd] p-4 border-b' to="/voter-id">
                    <h4 className='font-normal'>Voter ID</h4>
                    <ArrowForwardIosIcon className='allarrow-verify'/>
                </Link>
                <Link className='flex justify-between items-center border-[#dbdbdb] hover:bg-[#f0f8fd] p-4 border-b' to="/face">
                    <h4 className='font-normal'>Face</h4>
                    <ArrowForwardIosIcon className='allarrow-verify'/>
                </Link>
                <Link className='flex justify-between items-center border-[#dbdbdb] hover:bg-[#f0f8fd] p-4 border-b' to="/address">
                    <h4 className='font-normal'>Address</h4>
                    <ArrowForwardIosIcon className='allarrow-verify'/>
                </Link> <Link className='flex justify-between items-center hover:bg-[#f0f8fd] p-4' to="/past-employment-details">
                    <h4 className='font-normal'>Past Employment</h4>
                    <ArrowForwardIosIcon className='allarrow-verify'/>
                </Link>
            </div>
            </div>
        </>
    )
}

export default BackgroundVerification